export const getEventTotalsRespMaritime = () => {
  return {
    countEvents: {
      preSignol: 5127,
      postSignol: 11068,
    },
    countOperators: 94,
    countOperatorUsers: 61,
  };
};
